// extracted by mini-css-extract-plugin
module.exports = {"button":"postList-module--button--1jaLn","disabled":"postList-module--disabled--qbvaO"};